/** @format */

// @ts-nocheck

/**
 *
 issuedStatusName是String下发状态
 */

export default function() {
  if ('total' == this.businessType) {
    return [
      {
        // title: '机构(车场)名称',
        title: this.vm.activeKey == 0 ? '机构名称' : '车场名称',
        dataIndex: this.vm.activeKey == 0 ? 'orgName' : 'parkName',
        width: 180,
        scopedSlots: { customRender: 'parkName' }
        // customRender: (text: any, record: any, index: number) =>
        //   'orgName' in record ? record.orgName : record.parkName,
      },
      {
        title: '时间',
        dataIndex: 'reportDay',
        width: 140
      },

      {
        title: '临停收费',
        // dataIndex: 'fixedNum',

        children: [
          {
            title: '交易笔数',
            dataIndex: 'tempNum',
            width: 120
          },
          {
            title: '收入',
            dataIndex: 'tempAmount',
            width: 120
          }
        ]
      },
      {
        title: '车位管理费',
        // dataIndex: 'fixedNum',

        children: [
          {
            title: '交易笔数',
            dataIndex: 'manageFeeNum',
            width: 120
          },
          {
            title: '收入',
            dataIndex: 'manageFee',
            width: 120
          }
        ]
      },

      {
        title: '车位租赁费',
        // dataIndex: 'fixedNum',

        children: [
          {
            title: '交易笔数',
            dataIndex: 'rentalNum',
            width: 120
          },
          {
            title: '收入',
            dataIndex: 'rentalAmount',
            width: 120
          }
        ]
      },

      {
        title: '合计收入',
        dataIndex: 'total',
        width: 200
      }
    ];
  } else if ('fixed' == this.businessType) {
    return [
      {
        // title: '机构(车场)名称',
        title: this.vm.activeKey == 0 ? '机构名称' : '车场名称',
        scopedSlots: { customRender: 'parkName' },
        dataIndex: this.vm.activeKey == 0 ? 'orgName' : 'parkName',
        // customRender: (text: any, record: any, index: number) =>
        //   'orgName' in record ? record.orgName : record.parkName,
        width: 180
      },
      {
        title: '时间',
        dataIndex: 'reportDay',
        width: 140
      },

      {
        title: '车位管理费',
        // dataIndex: 'fixedNum',

        children: [
          {
            title: '交易笔数',
            dataIndex: 'managementFeeNum',
            width: 120
          },
          {
            title: '收入',
            dataIndex: 'managementFee',
            width: 120
          }
        ]
      },

      {
        title: '车位租赁费',
        // dataIndex: 'fixedNum',

        children: [
          {
            title: '交易笔数',
            dataIndex: 'monthlyFeeNum',
            width: 120
          },
          {
            title: '收入',
            dataIndex: 'monthlyFee',
            width: 120
          }
        ]
      },
      {
        title: '收费渠道',
        // dataIndex: 'fixedNum',

        children: [
          {
            title: '现金',
            dataIndex: 'cashAmount',
            width: 120
          },
          {
            title: '微信',
            dataIndex: 'wechatAmount',
            width: 120
          },
          {
            title: '支付宝',
            dataIndex: 'ailpayAmount',
            width: 120
          },
          {
            title: '银行转账',
            dataIndex: 'bankAmount',
            width: 120
          },
          {
            title: '其它',
            dataIndex: 'otherAmount',
            width: 120
          }
        ]
      },

      {
        title: '合计收入',
        dataIndex: 'totalAmount',
        width: 200
      }
    ];
  }
  //临停
  return [
    {
      // title: '机构(车场)名称',
      title: this.vm.activeKey == 0 ? '机构名称' : '车场名称',
      dataIndex: this.vm.activeKey == 0 ? 'orgName' : 'parkName',
      width: 180,
      scopedSlots: { customRender: 'parkName' }
      // customRender: (text: any) => text || '--',
    },
    {
      title: '时间',
      dataIndex: 'reportDay',
      width: 140
      // customRender: (text: any) => text || '--',
    },
    {
      title: '交易订单数',
      dataIndex: 'totalNum',
      width: 120,
      customRender: (text: any) => text || '--'
    },
    {
      title: '交易总金额',
      // dataIndex: 'fixedNum',
      width: 120,
      customRender: (text: any) => text || '--',
      children: [
        {
          title: '应收金额',
          dataIndex: 'totalAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '优惠金额',
          dataIndex: 'discountAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '应收未收',
          dataIndex: 'unpayAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '特殊减免',
          dataIndex: 'cancelAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '实收金额',
          dataIndex: 'paidAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        }
      ]
    },
    {
      title: '实收金额',
      // dataIndex: 'fixedNum',
      width: 120,
      customRender: (text: any) => text || '--',
      children: [
        {
          title: '现金',
          dataIndex: 'cashAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '微信',
          dataIndex: 'wechatAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '支付宝',
          dataIndex: 'ailpayAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: 'ETC',
          dataIndex: 'etcAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '储值卡',
          dataIndex: 'cardsAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        },
        {
          title: '其他',
          dataIndex: 'otherAmount',
          width: 120,
          customRender: (text: any) => text || '--'
        }
      ]
    }
  ];
}
